
import { Injectable } from '@angular/core';
import { HttpClient,HttpHeaders } from '@angular/common/http';

import { RegistrationFeedbackElement } from "../models/RegistrationFeedbackModel";

import { environment } from '../../environments/environment';

  ///import { environment } from '../../../environments/environment';
//   private apiUrl = environment.apiUrl;
  
@Injectable()
export class RegistrationFeedbackService {

    ////import { environment } from '../../../environments/environment';
    private apiUrl = environment.apiUrl;

constructor(private http: HttpClient) { }


  /////////////////////////////  ------------- CURD -----------------  /////////////////////

  addRegistrationFeedbackData(objj:RegistrationFeedbackElement) {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

      })
  };

    //return this.http.post('http://localhost:49587/api/RegistrationFeedback/AddRegistrationFeedback',  
    return this.http.post(""+this.apiUrl+"/RegistrationFeedback/AddRegistrationFeedback",
  JSON.stringify(objj),
   httpOptions
  )
  }
   
  getAllRegistrationFeedbackData( mid : number) {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

      })
  };
    return this.http.get(""+this.apiUrl+"/RegistrationFeedback/GetAllRegistrationFeedbackByMID?MID="+mid,httpOptions);
  }


  getAllRegistrationFeedbackByNatureData( feedback : string) {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

      })
  };
    return this.http.get(""+this.apiUrl+"/RegistrationFeedback/GetAllRegistrationFeedbackByNature?feedbacknature="+feedback,httpOptions);
  }

   /////////////////////////  ------------  GET ALL ------------   //////////////////////////


   //   FromAge, ToAge, SexId, HealthIssue, HealthConditionFirst, HealthConditionLast, GuestRating, ZoneId, AreaId, CreatedBy, Category 
   GetAllRegistrationFeedbackReport(  FromAge:number,ToAge:number, Frdt:string, Todt:string, SexId:number,  HealthIssue:string, HealthConditionFirst:number, HealthConditionLast :number , GuestRating : number, ZoneId : number , AreaId : number, CreatedBy : number, Category : number  ) {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',
      })
  };
    
    return this.http.get(""+this.apiUrl+"/RegistrationFeedback/GetAllRegistrationFeedbackAll?FromAge="+FromAge+"&ToAge="+ToAge+"&SexId="+SexId+"&Frdt="+Frdt+"&Todt="+Todt+"&HealthIssue="+HealthIssue+"&HealthConditionFirst="+HealthConditionFirst+"&HealthConditionLast="+HealthConditionLast+"&GuestRating="+GuestRating+"&ZoneId="+ZoneId+"&AreaId="+AreaId+"&CreatedBy="+CreatedBy+"&Category="+Category,httpOptions);
   //return this.http.get("http://localhost:49587/api/RegistrationFeedback/GetAllRegistrationFeedbackAll?FromAge="+FromAge+"&ToAge="+ToAge+"&Frdt="+Frdt+"&Todt="+Todt+"&SexId="+SexId+"&HealthIssue="+HealthIssue+"&HealthConditionFirst="+HealthConditionFirst+"&HealthConditionLast="+HealthConditionLast+"&GuestRating="+GuestRating+"&ZoneId="+ZoneId+"&AreaId="+AreaId+"&CreatedBy="+CreatedBy+"&Category="+Category,httpOptions);

   // //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////  FromAge, ToAge, SexId, HealthIssue, HealthConditionFirst, HealthConditionLast, GuestRating, ZoneId, AreaId, CreatedBy, Category 
   
  }
  
  getAllFeedbackUserData( Frdt:string, Todt:string,  CreatedBy : number) {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

      })
  };
  
   return this.http.get(""+this.apiUrl+"/RegistrationFeedback/GetAllFeedbackUserData?Frdt="+Frdt+"&Todt="+Todt+"&CreatedBy="+CreatedBy,httpOptions);

 // return this.http.get("http://localhost:49587/api/RegistrationFeedback/GetAllFeedbackUserData?Frdt="+Frdt+"&Todt="+Todt+"&CreatedBy="+CreatedBy,httpOptions);


  }




}
